import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import clsx from 'clsx'
import { getThemeClassName } from 'lib/theme/themeUtils'

const SpacerContainer = styled.div<{ height: number }>`
  width: 100%;
  height: ${props => rem(props.height)};

  &.background-color-white {
    background-color: ${props => props.theme.palette.neutral.default.eight};
  }

  &.background-color-grey {
    background-color: ${props => props.theme.palette.neutral.default.seven};
  }

  &.background-color-dark {
    background-color: ${props => props.theme.palette.neutral.default.eight};
  }
`

function ContentfulSpacer({ backgroundColor = 'white', space }: App.ComponentSpacer) {
  return (
    <SpacerContainer
      height={Number(space)}
      className={clsx(
        `background-color-${backgroundColor}`,
        getThemeClassName({ mobile: backgroundColor === 'dark' ? 'inverse' : 'default' }),
      )}
    />
  )
}

export default ContentfulSpacer
